import router from '@/router'
import throttle from 'lodash/throttle'
import { dateFormatString } from '@/utils'
const alertThrottle = throttle(
  function (msg) {
    window.$alert(msg)
  },
  5 * 1000,
  { trailing: false }
) // sec
const response = {
  fulfilled: function (response) {
    // Do something with response data
    return response
  },
  rejected: function (error) {
    let reloadYn = true
    let msg = dateFormatString(new Date(), 'yyyy/MM/dd hh:mm:ss') + '<br>'
    if (error.response) {
      const { data } = error.response
      const { errorCode, message, alertMessages } = data
      console.log(errorCode)
      if (message && errorCode === '449') {  // 直接顯示訊息
        // session invalid manually
        alertThrottle(data.message + '<br>' + dateFormatString(new Date(), 'yyyy/MM/dd hh:mm:ss'))
      }
      if (errorCode === '516') { // 請求端 例外處理(登入忘記密碼處理confirmYN與取消動作)
        error.response.status = 516
      }
      if (errorCode === '517') { // 請求端 例外處理 傳遞自定義錯誤訊息
        error.response.status = 517
      }
      if (errorCode === '518') { //  請求端 例外處理(登入忘記密碼處理alertYN)
        error.response.status = 518
      }
      if (errorCode === '519') { //  請求端 例外處理(登入忘記密碼處理confirmYN)
        error.response.status = 519
      }
      switch (error.response.status) {
        case 401:
          router.goLogin()
          msg = null
          break
        case 400:
          msg = msg + '400-傳送資料錯誤，請聯絡程式人員'
          break
        case 404:
          msg = msg + '404-伺服器連線錯誤，請聯絡IT人員'
          console.log(error.response)
          break
        case 500:
          msg = msg + '系統忙碌中，請稍後再試，如持續發生，請聯絡服務人員'
          break
        case 408:
          msg = msg + '408-核心系統忙碌中，請稍後再試'
          break
        case 517:
          msg = msg + alertMessages[0]
          break
        case 518: // 尚未登入進入忘記密碼區域
            reloadYn = false
          break
        default:
          msg = msg + '【保經公告】目前系統維運或換版中，暫停登入服務（包含行動投保及業務同仁上課），請依公告恢復時間再回來使用！（如有疑問可洽保經窗口）'
      }
    } else {
      msg = msg + '999-系統連不上，請確認網路狀況與環境問題'
    }
    if (msg != null) {
      window.$alert(msg).then(() => {
        if (reloadYn) {
          window.location.reload()
        }
      })
    }
    return Promise.reject(error)
  }
}
export default response
